import React from 'react';
import Slider from "react-slick";

import SectionTitle from '../../components/SectionTitle'

import SingleService from '../../components/Service/SingleService';

import serviceImg1 from '../../assets/images/service/1.png'
import serviceImg2 from '../../assets/images/service/2.png'
import serviceImg3 from '../../assets/images/service/3.png'
import serviceImg4 from '../../assets/images/service/4.png'
import serviceImg5 from '../../assets/images/service/5.png'
import serviceImg6 from '../../assets/images/service/6.png'
const Service = () => {

    const featuresSettings = {
        dots: false,
        arrows: true,
        infinite: true,
        centerMode: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                }
            }
        ]
    };

    return (
        <div className="react_popular_topics pt---100 pb---70">
            <div className="container">
                <SectionTitle Title="Core Aptitude Domains" />
                <div className="features-slider wow animate__fadeInUp" data-wow-duration="0.3s">
                    <Slider {...featuresSettings}>
                        <div className="px-2">
                            <SingleService
                                itemImg={serviceImg1}
                                title="Linguistic Intelligence"
                                description="The ability to effectively use language to express ideas and understand others through words."
                            />
                        </div>
                        <div className="px-2">
                            <SingleService
                                itemImg={serviceImg2}
                                title="Logical-Mathematical Intelligence"
                                description="The capacity for logical reasoning, problem-solving, and understanding mathematical concepts."
                            />
                        </div>
                        <div className="px-2">
                            <SingleService
                                itemImg={serviceImg3}
                                title="Visual-Spatial Intelligence"
                                description="The ability to visualize and manipulate objects in space, thinking in pictures and images."
                            />
                        </div>
                        <div className="px-2">
                            <SingleService
                                itemImg={serviceImg4}
                                title="Interpersonal Intelligence"
                                description="The capacity to understand and interact effectively with others, recognizing their emotions and motivations."
                            />
                        </div>
                        <div className="px-2">
                            <SingleService
                                itemImg={serviceImg5}
                                title="Existential Intelligence"
                                description="The ability to contemplate deep questions about human existence, meaning, and purpose in life."
                            />
                        </div>
                        <div className="px-2">
                            <SingleService
                                itemImg={serviceImg6}
                                title="Intrapersonal Intelligence"
                                description="The capacity for self-awareness and understanding one's own emotions, motivations, and inner states."
                            />
                        </div>
                    </Slider>
                </div>
            </div>
        </div>
    );
}

export default Service;